import type { TrpcProxyClient } from '../../trpc';
import type { PublishedWorkoutStatusDomain } from '@strength/domain';

export const sendTransaction_PublishedWorkoutStatusAsync = async (
  trpc: TrpcProxyClient,
  args: PublishedWorkoutStatusDomain.Command,
): Promise<{ lastSyncId: number }> => {
  switch (args.type) {
    case 'CancelBlockWorkout':
      return trpc.workoutStatus.cancelBlockWorkout.mutate(args.input);
    case 'UpdateAthleteWorkoutStatus':
      return trpc.workoutStatus.updateAthleteWorkout.mutate(args.input);
    default:
      const _: never = args;
      throw new Error(`Unknown args type: ${(args as any).type}`);
  }
};
